<template>
    <cadastro-simples-form
        endpoint="lingua-indigena"
        rota-base="/admin/lingua-indigena"
        titulo-singular="Língua Indígena"
        :campos-extras='[{"campo":"codigo_inep","label":"Código INEP","tipo":"string","maxLength":10}]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
